// Dates, in one place. Four pages had the same formatter copied into them, and
// they had already drifted: one said "never" for a missing value, another "—".

// "16 Aug, 20:58" rather than "8/16/2026, 8:58:52 PM" — the long form wraps to
// two lines on a phone and the seconds were never the question.
export const formatDate = (value?: string, fallback = '—') =>
  value
    ? new Date(value).toLocaleString(undefined, {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
      })
    : fallback;

// "4m ago" for anything recent, the date once it stops being about recency.
// What a developer wants from a generation list is "did my last call land",
// which an absolute timestamp makes them compute.
export function formatAgo(value?: string, fallback = '—'): string {
  if (!value) return fallback;
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return fallback;

  const seconds = Math.round((Date.now() - then) / 1000);
  if (seconds < 0) return formatDate(value, fallback);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 7 * 86_400) return `${Math.floor(seconds / 86_400)}d ago`;
  return formatDate(value, fallback);
}

// Credits are counted in whole units and get large; 20 000 reads faster than
// 20000 in a column of numbers.
export const formatCredits = (value: number) => value.toLocaleString('en-US').replace(/,/g, ' ');
